<template>
    <div class="Vehicle" style="background-color:rgb(245,245,249);">
        <Gnb v-bind:gnbCode=gnbCode v-bind:loginInfo1=loginInfo1 v-bind:loginInfo2=loginInfo2 />
        <div style="width:100%;" class="d-flex flex-row "  >
            <Navs v-bind:navCode1=navCode1 v-bind:navCode2=navCode2 v-bind:NavList=NavList />
            <div class="mt-3" style="width:100%; background-color:rgb(245,245,249);">
                <PageCrumbs v-bind:pTitles=pTitles v-bind:pCrumbs=pCrumbs />
                <div class="content" style="width:100%;min-height:770px;padding:2px 15px; background-color:rgb(245,245,249);">
                    <v-card elevation="1" class="mt-3 pa-5" >
                        <h3>Manager Info</h3>
                        <v-simple-table>
                            <tbody>
                                <tr>
                                    <th class="listHeader tableLinerT" style="width:20%">Manager ID</th>
                                    <td class="tableLinerT text-left pl-5" style="width:30%">{{modUsrID}}</td>
                                    <th class="listHeader tableLinerT" style="width:20%">National</th>
                                    <td class="tableLinerT text-left pl-5" style="width:30%">{{NAT_NAME_KR}}</td>
                                </tr>
                                <tr>
                                    <th class="listHeader tableLinerB">Name</th>
                                    <td class="text-left pl-5 tableLinerB">{{USR_NM}}</td>
                                    <th class="listHeader tableLinerB" >Phone</th>
                                    <td class="text-left pl-5 tableLinerB">{{PHONE}}</td>
                                </tr>
                                <tr>
                                    <th class="listHeader tableLinerB">Department</th>
                                    <td class="text-left pl-5 tableLinerB">{{DEPARTMENT}}</td>
                                    <th class="listHeader tableLinerB" >Posistion</th>
                                    <td class="text-left pl-5 tableLinerB">{{POSITION}}</td>
                                </tr>
                                <tr>
                                    <th class="listHeader tableLinerB">Level</th>
                                    <td class="text-left pl-5 tableLinerB">{{AUTH_LEVEL}}</td>
                                    <th class="listHeader tableLinerB" >Status</th>
                                    <td class="text-left pl-5 tableLinerB">
                                            <div v-if="USR_STATUS==1">Disable</div>
                                            <div v-if="USR_STATUS==2">Enable</div>
                                        </td>
                                </tr>
                                <tr>
                                    <th class="listHeader tableLinerB">Registration Date</th>
                                    <td class="text-left pl-5 tableLinerB">{{INS_DTM}}</td>
                                    <th class="listHeader tableLinerB" >Approval ID</th>
                                    <td class="text-left pl-5 tableLinerB">{{INS_USR_ID}}</td>
                                </tr>
                            </tbody>
                       </v-simple-table>
                   
                        <div class="mt-10">
                            <div class="d-flex justify-space-between dense pa-0 ">
                                <div class="pa2 " >
                                    <v-btn dark class="backBtn px-5"  @click="goBack" >Back</v-btn>
                                </div>
                                <div class="pa2 ">
                                    <!--
                                    <v-btn color="red lighten-2" small dark class="ml-2 px-5">Delete</v-btn> -->
                                    <v-btn dark class="registerBtn ml-2 px-6" @click="editInfo()">Edit</v-btn>
                                </div>
                            </div>
                        </div>

                    </v-card>
                </div>
            </div>
        </div>
        <Footer/>

    </div>
</template>

<style scoped>
    th {height:38px;}
    .rowList { padding:5px 0;}
    .tableLinerR {border-right:1px solid rgb(0, 0, 0, 0.12)}
    .tableLinerB {border-bottom:1px solid rgb(0, 0, 0, 0.12)}
    .tableLinerT {border-top:1px solid rgb(0, 0, 0, 0.12)}
    tbody tr:hover { background-color: transparent !important; }
</style>

<script>
import Gnb from '@/components/gnbComponent.vue'
import PageCrumbs from '@/components/pageCrumbs.vue'
import Footer from '@/components/footerComponent.vue'
import Navs from '@/components/nav.vue'

export default {
    name: 'MemberDetail',
    components: { Gnb, Footer, PageCrumbs,  Navs, },
    data () {
        return {
            // login Info
            gnbCode:"9", loginInfo1: "", loginInfo2: "", loginInfo3: "",
            navCode1:1, navCode2:11, 
            // Page Title & Breadcrumbs
            pTitles: "List",
            pCrumbs: [ { text: 'Home', disabled: true,}, { text: 'Setup', disabled: true,}, { text: 'User Management', disabled: true,}, { text: 'List', disabled: true,}, { text: 'Detail', disabled: false,}],
            NavList: [ 
                        { title: 'User Management', nums: '1',
                            items: [ { title: 'List', nums:11, href:'/Manager', icons:'mdi-format-list-bulleted' }
                                    , { title: 'New Registration', nums:12, href:'/ManagerWrite' , icons:'mdi-lead-pencil' }
                                    ],
                        },
                    ],     

            modUsrID:'',      

            USR_NM:"", NAT_NAME_KR:"", EMIAL:"", HP:"", PHONE:"",  
            DEPARTMENT:"", POSITION:"", AUTH_LEVEL:"", USR_STATUS:"", INS_DTM:"",  INS_USR_ID :"", 
            emptyFlag: false,
        }
    },

    beforeCreate() {
        let uuid = localStorage.getItem("e3MngID");
        let uauthcode = localStorage.getItem("e3MngCode"); 
        if(uuid != '' && uauthcode !='') {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "uid": uuid, "authCode": uauthcode})
            };
            //console.log(JSON.stringify({ "uid": uuid, "authCode": uauthcode}));
            fetch('https://api.e3bss.com/_APP/POC/validAuthUsr.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            })
            .then((json) => {
                if(json.result != "success") {
                    this.$router.replace('RequireLogin');
                } 
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        } else {
             this.$router.replace('RequireLogin');
        }
    },

    created() {
        this.loginInfo1=localStorage.getItem("e3MngID");
        this.loginInfo2=localStorage.getItem("e3MnglgDTM");
        this.loginInfo3=localStorage.getItem("e3MngCode");
        //console.log('param 확인' + this.$route.params.modMngID);
        this.modUsrID = this.$route.params.modMngID;
        if(this.modUsrID == '' || this.modUsrID == undefined) {
            this.modUsrID = localStorage.getItem("modMngID");
        }

        if(this.modUsrID != '') {
            this.getInfo();
            //this.getHistory();
        } else {
            alert("Not Data");
             this.$router.replace('Member');
        }
        window.scrollTo(0, 0);
    },

    methods : {
        
        // API Async 
        getInfo() {
            var requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "R"
                    , "modUsrID": this.modUsrID
                })
            };
            
            fetch('https://api.e3bss.com/_APP/POC/Manager.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json );
                if(json.result == "success") {
                    this.USR_NM = json.USR_NM; this.NAT_NAME_KR = json.NAT_NAME_KR;
                    this.EMIAL = json.EMIAL; 
                    this.HP = json.HP; this.PHONE = json.PHONE;
                    this.DEPARTMENT = json.DEPARTMENT; this.POSITION = json.POSITION; 
                    this.AUTH_LEVEL = json.AUTH_LEVEL; this.USR_STATUS = json.USR_STATUS; 
                    this.INS_DTM = json.INS_DTM;
                    this.INS_USR_ID = json.INS_USR_ID;
                    this.emptyFlag = false;
                } else {
                    this.emptyFlag = true;
                }
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        },

        // back button
        goBack() {
            //console.log('back');
            //return this.$router.go(-1);
            this.$router.push({ name: 'Manager'});
        },

        editInfo() {
            this.$router.push({ name: 'ManagerWrite', params: { modMngID: this.modUsrID, asyncActType: "U" }})
        }

    }

}
</script>
